import { FC } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useRoles } from "../../../auth/useRoles";
import { canBulkSyncWarehouse } from "../../../auth/permissions";

export const WarehouseSyncMenu: FC = () => {
  const navigate = useNavigate();
  const roles = useRoles();

  // Compliance and Risk hold no global role but own this page, so gate on the same helper the page
  // and the nav tab use rather than on useIsAdmin.
  if (!canBulkSyncWarehouse(roles)) {
    return null;
  }

  return (
    <Box display="flex" width="100%" alignItems="center">
      <IconButton
        onClick={() => navigate("/home")}
        sx={{ color: "secondary.main" }}
      >
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h5">Warehouse sync</Typography>
    </Box>
  );
};
